import { Controller } from "@hotwired/stimulus"

// Handles star rating selection for overall and category ratings
export default class extends Controller {
  static targets = ["input", "categoryInput", "container"]

  connect() {
    // Initialize overall rating display
    if (this.hasInputTarget && this.hasContainerTarget) {
      const currentRating = parseInt(this.inputTarget.value) || 0
      if (currentRating > 0) {
        this.updateOverallRatingDisplay(currentRating)
      }
    }

    // Initialize category ratings display
    if (this.hasCategoryInputTargets) {
      this.categoryInputTargets.forEach((input) => {
        const category = input.dataset.category
        const rating = parseInt(input.value) || 0
        if (rating > 0) {
          this.updateCategoryRatingDisplay(category, rating)
        }
      })
    }
  }

  selectRating(event) {
    event.preventDefault()
    event.stopPropagation()
    const button = event.currentTarget
    const rating = parseInt(button.dataset.rating)
    
    if (!rating || isNaN(rating)) {
      console.error("Invalid rating:", button.dataset.rating)
      return
    }
    
    if (this.hasInputTarget) {
      this.inputTarget.value = rating
      this.updateOverallRatingDisplay(rating)
    } else {
      console.error("Input target not found")
    }
  }

  selectCategoryRating(event) {
    event.preventDefault()
    event.stopPropagation()
    const button = event.currentTarget
    const category = button.dataset.category
    const rating = parseInt(button.dataset.rating)
    
    if (!category || !rating || isNaN(rating)) {
      console.error("Invalid category or rating:", category, button.dataset.rating)
      return
    }
    
    // Find the hidden input for this category
    const categoryInput = this.categoryInputTargets.find(input => 
      input.dataset.category === category
    )
    
    if (categoryInput) {
      categoryInput.value = rating
      this.updateCategoryRatingDisplay(category, rating)
    } else {
      console.error("Category input not found for:", category)
    }
  }

  updateOverallRatingDisplay(rating) {
    if (!this.hasContainerTarget) return

    const buttons = this.containerTarget.querySelectorAll(".star-rating-btn")
    buttons.forEach((button) => {
      const buttonRating = parseInt(button.dataset.rating)
      if (buttonRating <= rating) {
        button.classList.remove("text-gray-300")
        button.classList.add("text-yellow-400")
      } else {
        button.classList.remove("text-yellow-400")
        button.classList.add("text-gray-300")
      }
    })
  }

  updateCategoryRatingDisplay(category, rating) {
    // Find all category star buttons for this category within this controller's element
    const categoryButtons = this.element.querySelectorAll(
      `.category-star-btn[data-category="${category}"]`
    )
    
    categoryButtons.forEach((button) => {
      const buttonRating = parseInt(button.dataset.rating)
      if (buttonRating <= rating) {
        button.classList.remove("text-gray-300")
        button.classList.add("text-yellow-400")
      } else {
        button.classList.remove("text-yellow-400")
        button.classList.add("text-gray-300")
      }
    })
  }
}
